module.exports = __webpack_public_path__ + "static/media/sgd-13.4c66ead8.png";